module.exports = __webpack_public_path__ + "static/media/manage-health-rec.b0a456b8.png";